import { useSettings } from "Settings";

const dayCounts = [7, 1, 7, 3, 5, 7];
const jumpCounts = [7, 1, 7, 3, 7, 7];
const descriptions = [
  "Calendar Week",
  "Today",
  "Yesterday +6",
  "Yesterday +2",
  "Working Week",
  "Calendar Week (sun)",
];

const opts = dayCounts.map((x, i) => ({
  dayCount: x,
  jumpCount: jumpCounts[i],
  description: descriptions[i],
}));

export function useDateRangeSettings() {
  const isMobile = /Mobi/.test(window.navigator.userAgent);
  const [settings] = useSettings();

  const rangeType = isMobile ? 1 : settings.dayRange || 0;

  return {
    current: opts[rangeType],
  };
}
